import React from "react";
import Button from '@mui/material/Button';
import { ValidateTestMethodInput } from "./ValidateTestMethodInput";
const btnsArray = [
  { operation: "Display" },
  { operation: "Change" },
  {
    operation: "Create",
    navPath: (navigate) => navigate(`/TestMethod/Create`),
  },
];

export default function OverviewButtons({
  testMethod,
  navigate,
  _getTestMethodExists,
  _createErrorMessage,
}) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
      }}
      className="customButton"
    >
      {btnsArray.map(({ operation, navPath }, i) => (
        <div style={{ width: "48%", marginBottom: 15 }}>
          <Button
            className="btn btn-primary w-100"
            key={operation}
            onClick={() => {
              if (operation === "Create") {
                navPath(navigate);
                return;
              }

              let validationTestMethodResult = ValidateTestMethodInput(
                testMethod,
                _createErrorMessage
              );

              if (!validationTestMethodResult) {
                return;
              }

              _getTestMethodExists(
                { data: { Id: testMethod } },
                ({ data: isExist }) => {
                  if (!isExist) {
                    _createErrorMessage("107");
                    return;
                  }
                  const navigationUrl = `/TestMethod/${testMethod}/${operation}`;
                  navigate(navigationUrl);
                }
              );
            }}
          >
            {operation}
          </Button>
        </div>
      ))}
    </div>
  );
}
